export default __webpack_public_path__ + "media/images/features/local_delivery/table_frame-f706245e5c42ba710aadaa929866d16b.png";